import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import About from './pages/About';
import Clients from './pages/Clients';
import Certificate from './pages/Certificate';
import Events from './pages/Events';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import ProductDetail from './pages/ProductDetail';
import SearchResults from './pages/SearchResults';



function App(){
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/about" element={<About/>} />
          <Route path="/clients" element={<Clients/>} />
          <Route path="/certificate" element={<Certificate/>} />
          <Route path="/products" element={<Products/>} />
          <Route path="/products/:categoryId" element={<Products/>} />
          <Route path="/products/:categoryId/:subId" element={<Products/>} />
          <Route path="/product/:id" element={<ProductDetail/>} />
          <Route path="/search" element={<SearchResults/>} />
          <Route path="/events" element={<Events/>} />
          <Route path="/gallery" element={<Gallery/>} />
          <Route path="/contact" element={<Contact/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
